import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Textarea, Label, Input } from "rbx";

import { useBookingCodeDetails } from "../../utils/hooks";

import { useCurrentUserRoles } from "../Authorization";

import {
  DriverSelect,
  BookingCodeSelect,
  DateInput,
  OperatorSelect,
  CalendarDateSelect
} from "../inputs";

const BookingForm = ({
  state,
  onChange,
  employeeWhere = {},
  bookingCodeWhere = {},
  adding = false,
  onDaysChange = () => {},
  days = [],
  isBookable,
  user
}) => {
  const { data: bkData } = useBookingCodeDetails(state.BookingCodeRecIdRef);
  const roles = useCurrentUserRoles();

  return (
    <div style={{ minWidth: 800 }}>
      <Field className="grid-override" kind="group">
        <Control expanded>
          <Label>Employee</Label>
          <DriverSelect
            icon="user"
            name="EmployeeRecIdRef"
            useSupervisorFilter={
              roles.every(role => role !== "ADMIN") &&
              (window.location.href.includes("pto/booking-history") ||
                window.location.href.includes("pto/pto-request"))
            }
            user={user}
            value={state.EmployeeRecIdRef}
            where={employeeWhere}
            onChange={({ target: { value, name } }) => {
              onChange({ target: { name, value } });
            }}
          />
        </Control>
        <Control expanded>
          <Label>Booking Code</Label>
          <BookingCodeSelect
            icon="book-open"
            isBookable={isBookable}
            name="BookingCodeRecIdRef"
            value={state.BookingCodeRecIdRef}
            where={bookingCodeWhere}
            onChange={({ target: { value, name } }) => {
              onChange({ target: { value, name } });
            }}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Pickup Date</Label>
          <DateInput
            disabled={isBookable}
            name="PickupDate"
            value={state.PickupDate}
            onChange={onChange}
          />
        </Control>
        {bkData?.MultipleDays && adding && (
          <Control expanded>
            <Label>Multi. Day</Label>
            <CalendarDateSelect
              startDate={state.PickupDate}
              value={days}
              onChange={onDaysChange}
            />
          </Control>
        )}
        <Control expanded>
          <Label>User</Label>
          <OperatorSelect
            readOnly
            required
            icon="user"
            name="OperatorRecIdRef"
            value={state.OperatorRecIdRef}
            onChange={({ target: { value, name } }) => {
              onChange({ target: { name, value } });
            }}
          />
        </Control>
        <Control expanded>
          <Label>Created Date</Label>
          <Input readOnly value={state.CreatedDateTime} />
        </Control>
      </Field>
      {state.BookedTrip && (
        <Field>
          <Label>Booked Trip</Label>
          <Control>
            <Input
              disabled
              value={
                (new RegExp(/!(^[A-z]{2}[0-9]{2}\s)/).test(state.BookedTrip)
                  ? `${bkData.BookingCode} `
                  : "") + state.BookedTrip
              }
            />
          </Control>
        </Field>
      )}
      <Field>
        <Label>Comments</Label>
        <Control>
          <Textarea
            name="Comment"
            value={state.Comment}
            onChange={({ target: { name, value } }) =>
              onChange({ target: { name, value } })
            }
          />
        </Control>
      </Field>
    </div>
  );
};

BookingForm.propTypes = {
  employeeWhere: PropTypes.object,
  state: PropTypes.object,
  bookingCodeWhere: PropTypes.object,
  onChange: PropTypes.func,
  adding: PropTypes.bool,
  onDaysChange: PropTypes.func,
  days: PropTypes.array,
  isBookable: PropTypes.bool,
  user: PropTypes.object
};
export default BookingForm;
